import React from 'react'
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer';

const imageMap = {
    emailHeadIcon: require('../../../../images/emailHeadIcon.png'),
    googleValidatior: require('../../../../images/googleValidatior.svg'),
    smsHeadIcon: require('../../../../images/profilePage/sms_auth.svg'),
};

const ModalWrapper = ({ children, girlComponent, modalType, headerType, headerBgIcon, heading, onCloseHandler, modalCardClasses = "", customStyle }) => {

    const dispatch = useDispatch();
    const modal = useSelector(state => state.modal);

    const handleClose = () => {
        if (modalType !== 'confirmDescription') dispatch(toggleModal({ open: '' }));
        if (onCloseHandler) onCloseHandler();
    }

    return (
        <Modal open={modal['open'] === modalType} onClose={handleClose} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df aic jcc mainModalWrapper'>
            <>
                <div className={`mah80 oya bg1 shadow w100 bsbb df fdc maw700px br20px ${modalCardClasses} hideScrollbar`}
                    style={
                        customStyle ? customStyle : {
                            padding: headerType ? "0rem !important" : "2rem",
                            zIndex: 9,
                            marginTop: "2rem"
                        }}
                >
                    {headerType && ["primary"].includes(headerType)
                        ? <div className='bg-gradient3 p1rem df aic pr' style={{ height: "50px", padding: '1rem 1.5rem' }}>
                            <span className='c1'>{heading}</span>
                            <img className='pa' src={imageMap[headerBgIcon ?? "emailHeadIcon"]} alt="headerBgIcon" style={{ width: '80px', right: "80px", bottom: "0px" }} />
                        </div> : null
                    }
                    <div className={`pr ${modalType == 'fit-report' && 'osc'}`} style={{ padding: headerType ? "3rem" : "0rem" }}>{children}</div>
                </div>
                <div className='df jcc aic'>
                    {girlComponent && girlComponent}
                </div>
                <button onClick={handleClose} style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', bottom: '20px', background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280', fontSize: '13px', textDecoration: 'underline' }}>Close</button>
            </>
        </Modal>
    )
}

export default ModalWrapper